import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAtom, authTokenAtom } from '../../Data/Atoms';
import { createApiService } from '../../shared/apiConfig';
import { StaffApi } from '../../shared/api/axios-client';
import { decodeJwt } from '../../helpers/JwtDecoder';

const RedirectComponent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [auth, setAuth] = useAtom(authAtom);
  const [authToken, setAuthToken] = useAtom(authTokenAtom);
  const nav = useNavigate();
  
  const spotSyncUserId = (accessToken: string) => {
    const decodedToken = decodeJwt(accessToken);
    if (decodedToken) {
      return decodedToken.SpotSyncUserId || null;
    }
    return null;
  };
  useEffect(() => {
    const encodedRedirectUrl = searchParams.get('redirectUrl');
    const encodedAccessToken = searchParams.get('accessToken');

    if (encodedRedirectUrl && encodedAccessToken) {
      const redirectUrl = decodeURIComponent(encodedRedirectUrl);
      const accessToken = decodeURIComponent(encodedAccessToken);

      // Impersonate user with accessToken logic goes here
      // For example, set it in some user authentication context or state
      setAuthToken({ accessToken });
      const staffApi = createApiService(StaffApi);
      const spotSyncUserIdValue = spotSyncUserId(accessToken);
      staffApi.getStaffImpersonated({
                        id: spotSyncUserIdValue
                    }).then((staffResponse)=>{
                        setAuth({isLoggedIn: true, account: staffResponse.data.item as any, accessToken})
                        nav(redirectUrl);
                    })

      // Redirect to the decoded URL
      //window.location.href = redirectUrl;
    }
  }, [searchParams]);

  return null;
};

export default RedirectComponent;
